import Axios from "axios";

import { createRequest } from "helpers/tools";

import { baseURL } from "../../configurations/environment";
import { RequestConfig } from "../RequestConfig";

export const createDestination = async (form) => {
    return await createRequest({
        suffix: `destinations`,
        method: "post",
        payload: form,
        handleError: false,
    });
};
export const getDestinationFacebook = async () => {
    return await createRequest({
        suffix: `facebook/authorized-app-info`,
        method: "get",
        handleError: false,
    });
};
export const createDestinationFacebook = async (form) => {
    return await createRequest({
        suffix: `facebook/destinations`,
        method: "post",
        payload: form,
        handleError: false,
    });
};
export const getMetaCustomAudiences = async (payload) => {
    return await createRequest({
        handleError: true,
        method: "post",
        payload,
        suffix: "destinations/fb/ca/fetch",
    });
};

// Kept on Axios: returns the full response body as `data` and reads its message
// from a deeper `data.data.message` path that createRequest does not preserve.
export const createDestinationMetaCustomAudience = async (payload) => {
    let requestURL = baseURL + `/api/destinations/fb/ca/`;
    try {
        const response = await Axios.post(requestURL, payload, RequestConfig());
        return {
            status: true,
            message: response?.data?.data?.message,
            data: response.data,
        };
    } catch (error) {
        return {
            status: false,
            data: "",
            message: error.response?.data?.message,
        };
    }
};

// Kept on Axios: see createDestinationMetaCustomAudience note.
export const createMetaCustomAudience = async (payload) => {
    try {
        let requestURL = baseURL + `/api/destinations/fb/ca/create-on-facebook`;

        const response = await Axios.post(requestURL, payload, RequestConfig());
        return {
            status: true,
            message: response?.data?.data?.message,
            data: response.data,
        };
    } catch (error) {
        return {
            status: false,
            data: "",
            message: error.response?.data?.message,
        };
    }
};

export const addDestinationToTracker = async (destination_id, tracker_id) => {
    return await createRequest({
        suffix: `trackers/${tracker_id}/destinations`,
        method: "post",
        payload: destination_id,
        handleError: false,
    });
};

export const isAuthTikTok = async () => {
    return await createRequest({
        suffix: `tiktok/auth-url`,
        method: "get",
        handleError: false,
    });
};

export const googleEnhanceAuth = async (data) => {
    return await createRequest({
        suffix: "sources/google/auth-url",
        handleError: true,
        method: "post",
        payload: data,
    });
};

export const sendGoogleEnhancedData = async (googleData) => {
    return await createRequest({
        suffix: `destinations/google-enhance-connect`,
        method: "post",
        payload: googleData,
        handleError: false,
    });
};

export const sendGoogleEnhancedAccount = async (data) => {
    return await createRequest({
        suffix: `destinations/google-enhance-create`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

const normalizeTiktokAdvertisers = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }
    if (Array.isArray(payload?.advertisers)) {
        return payload.advertisers;
    }
    return [];
};

export const getTiktokAdvertisers = async (data) => {
    const response = await createRequest({
        suffix: "tiktok/advertisers",
        method: "get",
        handleError: false,
        params: {
            ...(data?.code && { code: data.code }),
            ...(data?.state && { state: data.state }),
        },
    });
    if (!response.status) {
        return response;
    }
    return {
        ...response,
        data: normalizeTiktokAdvertisers(response.data),
    };
};

export const getTiktokPixelsAsync = async (accountId) => {
    return await createRequest({
        suffix: "tiktok/get-pixels",
        method: "get",
        handleError: false,
        params: { account_id: accountId },
    });
};

export const getTiktokOfflineAsync = async (data) => {
    return await createRequest({
        suffix: `tiktok/offline-event-sets?code=${data?.code}&state=${data?.state}`,
        method: "get",
        handleError: false,
    });
};

export const postSelectedPixelsToService = async (data) => {
    return await createRequest({
        suffix: `tiktok/pixels`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const postSelectedOfflineToService = async (data) => {
    return await createRequest({
        suffix: `tiktok/offline-event-sets`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const destinationVisible = async () => {
    return await createRequest({
        suffix: `settings`,
        method: "post",
        payload: [],
        handleError: false,
    });
};

export const getTwitterAuthUrl = async () => {
    return await createRequest({
        suffix: "destinations/tw/auth-url",
        handleError: true,
        method: "get",
    });
};

export const isAuthTwitter = async () => {
    return await createRequest({
        suffix: `destinations/tw/auth-url`,
        method: "get",
        handleError: false,
    });
};

export const authorizeTwitter = async (data) => {
    return await createRequest({
        suffix: `destinations/tw/authorize`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const tiktokReLogin = async () => {
    return await createRequest({
        suffix: `tiktok/change-account`,
        method: "get",
        handleError: false,
    });
};

export const getGoogleEnhanceEvents = async () => {
    return await createRequest({
        suffix: `destinations/events`,
        method: "get",
        handleError: false,
    });
};

export const createGoogleEnhanceMapping = async (destination_id, data) => {
    return await createRequest({
        suffix: `destinations/google-enhance/${destination_id}/mapping`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getGoogleEnhanceMapping = async (destination_id) => {
    return await createRequest({
        suffix: `destinations/google-enhance/${destination_id}/mapping`,
        method: "get",
        handleError: false,
    });
};

export const createGoogleWebMapping = async (destination_id, data) => {
    return await createRequest({
        suffix: `destinations/google-web/${destination_id}/mapping`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getGoogleWebMapping = async (destination_id) => {
    return await createRequest({
        suffix: `destinations/google-web/${destination_id}/mapping`,
        method: "get",
        handleError: false,
    });
};

export const refreshGoogleEnhanceTags = async (destination_id) => {
    return await createRequest({
        suffix: "destinations/google-enhance/refresh-tags",
        handleError: false,
        method: "post",
        payload: { destination_id },
    });
};

export const getPinterestAuthUrl = async () => {
    return await createRequest({
        suffix: "destinations/pinterest/auth-url",
        handleError: true,
        method: "get",
    });
};

export const getPinterestPixels = async (data) => {
    let suffix = `destinations/pinterest/get-pixels`;
    if (data) {
        const code = data && data.code && data.code;
        const state = data && data.state && data.state;
        suffix = `destinations/pinterest/get-pixels?code=${code}&state=${state}`;
    }
    return await createRequest({
        suffix,
        method: "get",
        handleError: false,
    });
};

export const pinterestAuthorize = async (data) => {
    let suffix = `destinations/pinterest/authorize`;
    if (data) {
        const code = data && data.code && data.code;
        const state = data && data.state && data.state;
        suffix = `destinations/pinterest/authorize?code=${code}&state=${state}`;
    }
    return await createRequest({
        suffix,
        method: "get",
        handleError: false,
    });
};

export const savePinterestPixels = async (data) => {
    return await createRequest({
        suffix: `destinations/pinterest/pixels`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const postConnectImpact = async (payload) => {
    return await createRequest({
        suffix: "destinations/impact",
        handleError: true,
        method: "post",
        payload,
    });
};

export const getImpactCampaigns = async (destination_id) => {
    return await createRequest({
        suffix: `destinations/impact/${destination_id}/campaigns`,
        handleError: true,
        method: "get",
    });
};

export const getImpactActionTrackers = async (destination_id, campaign_id) => {
    return await createRequest({
        suffix: `destinations/impact/${destination_id}/${campaign_id}/action-trackers`,
        handleError: true,
        method: "get",
    });
};
export const postStoreImpactMappings = async (destination_id, payload) => {
    return await createRequest({
        suffix: `destinations/impact/${destination_id}/mappings`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const getImpactMappings = async (destination_id, payload) => {
    return await createRequest({
        suffix: `destinations/impact/${destination_id}/mappings`,
        handleError: true,
        method: "get",
        payload,
    });
};

export const getEvents = async () => {
    return await createRequest({
        suffix: `events`,
        handleError: true,
        method: "get",
    });
};

export const getIntegrationLogs = async (destinationID) => {
    return await createRequest({
        suffix: `destinations/integration-logs/${destinationID}`,
        handleError: true,
        method: "get",
    });
};
export const getMetaCustomAudienceStats = async (destination_id) => {
    return await createRequest({
        suffix: `destinations/fb/ca/${destination_id}/session-status`,
        handleError: true,
        method: "get",
    });
};
export const getTiktokCustomAudienceStats = async (destination_id) => {
    return await createRequest({
        suffix: `tiktok/ca/${destination_id}/session-status`,
        handleError: true,
        method: "get",
    });
};
export const authorizeTiktokCustomAudience = async (payload) => {
    return await createRequest({
        handleError: true,
        method: "post",
        payload,
        suffix: "tiktok/ca/authorize",
    });
};

// Kept on Axios: returns the full response body as `data` and reads its message
// from a deeper `data.data.message` path that createRequest does not preserve.
export const createDestinationTiktokCustomAudience = async (payload) => {
    let requestURL = baseURL + `/api/tiktok/ca/store`;
    try {
        const response = await Axios.post(requestURL, payload, RequestConfig());
        return {
            status: true,
            message: response?.data?.data?.message,
            data: response.data,
        };
    } catch (error) {
        return {
            status: false,
            data: "",
            message: error.response?.data?.message,
        };
    }
};

// Kept on Axios: multipart/form-data upload requiring custom headers not
// supported by createRequest.
export const createExternalTiktokCustomAudience = async (formData) => {
    let requestURL = baseURL + `/api/tiktok/ca/create-external`;
    try {
        const response = await Axios.post(requestURL, formData, {
            ...RequestConfig(),
            headers: {
                ...RequestConfig().headers,
                "Content-Type": "multipart/form-data",
            },
        });
        return {
            status: true,
            message: response?.data?.data?.message,
            data: response.data,
        };
    } catch (error) {
        return {
            status: false,
            data: "",
            message: error.response?.data?.message,
        };
    }
};

export const getSignalSightTaskActions = async () => {
    return await createRequest({
        suffix: "destinations/sstask/actions",
        handleError: true,
        method: "get",
    });
};

export const createSignalSightTaskDestination = async (payload) => {
    return await createRequest({
        suffix: "destinations/sstask",
        handleError: true,
        method: "post",
        payload,
    });
};

export const getSignalSightTaskMappings = async (destination_id) => {
    return await createRequest({
        suffix: `destinations/sstask/${destination_id}/mappings`,
        handleError: true,
        method: "get",
    });
};

export const saveSignalSightTaskMappings = async (destination_id, payload) => {
    return await createRequest({
        suffix: `destinations/sstask/${destination_id}/mappings`,
        handleError: true,
        method: "post",
        payload,
    });
};
